import CampaignsApi from '../../../../api/campaigns-api';
import actionTypes from '../constants/action-types';
import constants from '../../../../common/constants';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal, toggleDefaultErrorModal } from '../../../shared/info-modal/actions/info-modal-actions';

export const getCampaigns = () => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await CampaignsApi.getCampaigns();
      const data = response && response.data;
      dispatch(handleSuccessGetCampaigns(data));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const addCampaign = data => {
  return async dispatch => {
    dispatch(handleCreateCampaignInProgress(true));
    try {
      /* eslint-disable */
      const response = await CampaignsApi.addCampaign(data);
      /* eslint-enable */
      dispatch(getCampaigns());
      dispatch(toggleCreateCampaignModal(false));
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'CAMPAIGNS.SUCCESS_CREATE_MESSAGE'));
    } catch (error) {
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const editCampaign = data => {
  return async dispatch => {
    dispatch(handleCreateCampaignInProgress(true));
    try {
      /* eslint-disable */
      const response = await CampaignsApi.editCampaign(data);
      /* eslint-enable */
      dispatch(getCampaigns());
      dispatch(toggleCreateCampaignModal(false));
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'CAMPAIGNS.SUCCESS_EDIT_MESSAGE'));
    } catch (error) {
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const requestInstallLink = (username, email) => {
  return async dispatch => {
    dispatch(handleCreateCampaignInProgress(true));
    try {
      /* eslint-disable */
      const response = await CampaignsApi.requestInstallLink(username, email);
      /* eslint-enable */
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleMobileCampaignModal(false));
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'CAMPAIGNS.SUCCESS_REQUEST_INSTALL_LINK_MESSAGE'));
    } catch (error) {
      dispatch(handleCreateCampaignInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const handleSuccessGetCampaigns = data => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_CAMPAIGNS,
    data,
  };
};

export const toggleCreateCampaignModal = (show, link) => {
  return {
    type: actionTypes.TOGGLE_CREATE_CAMPAIGN_MODAL,
    data: {
      show,
      link,
    },
  };
};

export const handleCreateCampaignInProgress = inProgress => {
  return {
    type: actionTypes.CREATE_CAMPAIGN_IN_PROGRESS,
    data: inProgress,
  };
};

export const toggleChooseCampaignModal = show => {
  return {
    type: actionTypes.TOGGLE_CHOOSE_CAMPAIGN_MODAL,
    data: show,
  };
};

export const toggleMobileCampaignModal = show => {
  return {
    type: actionTypes.TOGGLE_MOBILE_CAMPAIGN_MODAL,
    data: show,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/campaigns/actions/campaigns-actions.js